import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { apiBaseUrl, apiVersion } from '../config';
import { retryAfterTimeout, addDays, ToastV2Service } from '@schenck/rotec-components';
import { SearchParams } from '../utils/interfaces/search.interface';
import { ErrorHandlerService } from 'src/services/error-handler/error-handler.service';

@Injectable()
export class SearchApi {
  private readonly http = inject(HttpClient);
  private readonly toastService = inject(ToastV2Service);
  private readonly errorHandlerService = inject(ErrorHandlerService);

  search(params: SearchParams): Observable<{ results: any[]; total: number }> {
    return this.http
      .post(`${apiBaseUrl}/search?api-version=/${apiVersion}`, this.addOneDayToDateToFilter(params))
      .pipe(
        retryAfterTimeout(2000, 5),
        catchError((error) => {
          this.errorHandlerService.setSearchError(error?.status ?? error?.error ?? true);
          throw error;
        }),
        tap(() => this.errorHandlerService.setSearchError(false)),
        map((result: any) => ({
          total: result.total,
          results: result.results,
        }))
      );
  }

  /**
   * When, in the frontend, the user selects "find everything until day X", we want to find everything until day X 23:59h.
   * Therefore we add one day before sending the filter to the backend.
   */
  private addOneDayToDateToFilter(params: SearchParams): SearchParams {
    return {
      ...params,
      filter: params.filter.map((filter) => {
        return !!filter.value.to
          ? { ...filter, value: { ...filter.value, to: addDays(new Date(filter.value.to), 1) } }
          : filter;
      }),
    };
  }
}
